import {ReactElement} from 'react';
import {Alert} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {FinishId} from 'interfaces/Finish';
import SectionSelect from '../SectionSelect';
import useFinishes from './hooks/useFinishes';

type Props = {
  deleteTrayFromSection: () => void;
  finishId: number | null;
  hasSelectedTray: boolean;
  onFinishChange: (finishId: FinishId) => void;
  setHasFinish: (hasFinish: boolean) => void;
  traySystemId: number;
};

export default function SelectFinish({
  finishId,
  deleteTrayFromSection,
  hasSelectedTray,
  onFinishChange,
  setHasFinish,
  traySystemId
}: Props): ReactElement {
  const {apiQueryStatus: getFinishesApiQueryStatus, apiResponse: getFinishesResponse} =
    useFinishes(traySystemId);
  const {t} = useTranslation('common');

  if (getFinishesApiQueryStatus.dataStatus.isError || !getFinishesResponse) {
    return <Alert severity="error">{t('common:errorLoadingFinishes')}</Alert>;
  }

  const finishes = getFinishesResponse.data;

  setHasFinish(finishes && finishes.length > 0);

  return (
    <SectionSelect
      id="select-finish"
      label={t('common:finish')}
      placeholder={t('common:selectFinishPlaceholder')}
      value={finishId}
      options={finishes}
      onChange={onFinishChange}
      hasSelectedTray={hasSelectedTray}
      deleteTrayFromSection={deleteTrayFromSection}
    />
  );
}
